export default {
    IN_CASH: 1,
    IN_INSTALLMENT: 2,
    CREDITCARD: 3,
};